import tippy from 'tippy.js';

export default function loadTippy() {
    tippy('[data-tippy-content]', {
        arrow:     true,
        animation: 'scale',
        zIndex:    9
    });

    tippy('[data-tippy-html]', {
        arrow:     true,
        animation: 'scale',
        zIndex:    9,
        allowHTML: true,
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
        }
    });
}